import { useSyncStatus } from './useSyncStatus';

export {
  getSyncTypeStatus,
  mergeSyncTypeStatus,
  SyncPersistenceProvider,
  useSyncModel,
  useSyncPersistence,
  useSyncRecordStatusSubscription,
} from './persistence';
export type { SyncModel, SyncRecordBase, SyncTypeStatus } from './persistence';
export * from './Photos';
export { ScanSynchronizerProvider, useScanSynchronizer } from './ScanSynchronizer';
export type { ActiveProgressTracker, ProgressDetails } from './SyncLogger';
export { usePreventNavigationDuringSync } from './usePreventNavigationDuringSync';
export { useSyncStatus } from './useSyncStatus';

export { useSaveScanData } from './useSaveScanData';

export {
  useScanDataSyncModel,
  useScanNoteSyncModel,
  useScanPhotoSyncModel,
} from './Models';

export { getAge } from './ScanSynchronizer/syncLib';

/** @deprecated */
export const useSyncScanDataPendingCount = () => useSyncStatus().scanDataSyncStatus.pending;
/** @deprecated */
export const useSyncScanPhotosPendingCount = () => useSyncStatus().photosSyncStatus.pending;

/** @deprecated */
export const useSyncScanProgress = () => useSyncStatus();
